import { useMutation } from '@biletiniz/apollo';
import { LOGOUT } from './gql/logout';

export const useLogout = () => {
  const [logoutMutation, { error, loading }] = useMutation(LOGOUT);

  const logout = logoutInfo => {
    return logoutMutation({
      variables: logoutInfo,
    });
  };

  return {
    error: error?.message,
    logout,
    loading,
  };
};
